import React from 'react'
import "../../stylings/topper.css"

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

//Toppers Photo

import ananya_joshi from '../../assest/topper photos/Ananya_Joshi.jpeg';
import jiana_koul from '../../assest/topper photos/jiana_koul.jpeg';
import rose_ansari from '../../assest/topper photos/rose_ansari.jpeg';

const Topper = () => {
    return (
        <div className="topper container">
            <div>
                <div className="topper-awards-heading">
                    <div className="topper-awards-icon">
                        <i className="fa-solid fa-trophy"></i>
                    </div>
                    <h3><span className='word-leader'>ACADEMIC</span> EXCELLENCE (2023-24)</h3>
                </div>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={20}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    }}
                    breakpoints={{
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 70
                        }
                    }}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <div className="card" >
                            <div className="img-container">
                                <img src={ananya_joshi} className="card-img-top" alt="1" />
                            </div>
                            <div className="card-body">
                                <p className='student-name'><strong>Name:</strong> Ananya Joshi</p>
                                {/* <p className="position"><strong>Position:</strong> 7th Position</p> */}
                                <p className='marks'><strong>Percentage:</strong> 92%</p>
                                <p className="class"><strong>Class:</strong> 6<sup>th</sup></p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="card" >
                            <div className="img-container">
                                <img src={jiana_koul} className="card-img-top" alt="1" />
                            </div>
                            <div className="card-body">
                                <p className='student-name'><strong>Name:</strong> Jiana Koul</p>
                                {/* <p className="position"><strong>Position:</strong> 6th Position</p> */}
                                <p className='marks'><strong>Percentage:</strong> 85%</p>
                                <p className="class"><strong>Class:</strong> 6<sup>th</sup></p>
                            </div>
                        </div>
                    </SwiperSlide>
                   <SwiperSlide>
                        <div className="card" >
                            <div className="img-container">
                                <img src={rose_ansari} className="card-img-top" alt="1" />
                            </div>
                            <div className="card-body">
                                <p className='student-name'><strong>Name:</strong> Rose Ansari</p>
                                {/* <p className="position"><strong>Position:</strong> 7th Position</p> */}
                                <p className='marks'><strong>Percentage:</strong> 79.16%</p>
                                <p className="class"><strong>Class:</strong> 6<sup>th</sup></p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="card" >
                            <div className="img-container">
                                <img src={ananya_joshi} className="card-img-top" alt="1" />
                            </div>
                            <div className="card-body">
                                <p className='student-name'><strong>Name:</strong> Ananya Joshi</p>
                                {/* <p className="position"><strong>Position:</strong> 7th Position</p> */}
                                <p className='marks'><strong>Percentage:</strong> 92%</p>
                                <p className="class"><strong>Class:</strong> 6<sup>th</sup></p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="card" >
                            <div className="img-container">
                                <img src={jiana_koul} className="card-img-top" alt="1" />
                            </div>
                            <div className="card-body">
                                <p className='student-name'><strong>Name:</strong> Jiana Koul</p>
                                {/* <p className="position"><strong>Position:</strong> 6th Position</p> */}
                                <p className='marks'><strong>Percentage:</strong> 85%</p>
                                <p className="class"><strong>Class:</strong> 6<sup>th</sup></p>
                            </div>
                        </div>
                    </SwiperSlide>
                   <SwiperSlide>
                        <div className="card" >
                            <div className="img-container">
                                <img src={rose_ansari} className="card-img-top" alt="1" />
                            </div>
                            <div className="card-body">
                                <p className='student-name'><strong>Name:</strong> Rose Ansari</p>
                                {/* <p className="position"><strong>Position:</strong> 7th Position</p> */}
                                <p className='marks'><strong>Percentage:</strong> 79.16%</p>
                                <p className="class"><strong>Class:</strong> 6<sup>th</sup></p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    )
}

export default Topper
